import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import "./index.css";

const SortByComponent = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);
  const [dropdownItem, setDropdownItem] = useState(props.sortBy);


  const dropdownItemObject = {
    "new":"Newest First",
    "old":"Oldest First",
    "desc":"Name (Z to A)",
    "asc":"Name (A to Z)"
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="rectangle-copy-5 text-align-right">

      <DropdownToggle caret>
        <span>Sort by: <span className="sort-by-date-modifi">{dropdownItemObject[dropdownItem]}</span></span>
      </DropdownToggle>
      <DropdownMenu>
         {
          Object.keys(dropdownItemObject).map((key, index)=> {
            return (
              <DropdownItem key={`sort-by-${index}`} 
                onClick={()=>{
                  setDropdownItem(key)
                  props.setSortBy(key)
                }}>{dropdownItemObject[key]}
                </DropdownItem>)
          })
         }
      </DropdownMenu>
    </Dropdown>
  );
}

export default SortByComponent;